const LATEST_SELECTED_SPONSOR_ID = 'latest_selected_sponsor_id';

export const cookieKeys = {
    LATEST_SELECTED_SPONSOR_ID
};
